import React from 'react'
import PropTypes from 'prop-types'
import * as PIXI from 'pixi.js'
import { getLocalTexture, replaceBaseTexture } from '../../utils'
import ImgFromTexture from '../../components/imgFromTexture'

const { BaseTexture } = PIXI

export default class TextureSelector extends React.Component {
  static propTypes = {
    textureName: PropTypes.string.isRequired,
    isSpine: PropTypes.bool,
  }

  static defaultProps = {
    isSpine: false,
  }

  replaceTexture = (event) => {
    const { props } = this
    const { files } = event.target
    const reader = new FileReader()
    const { textureName } = props

    reader.addEventListener('load', (ev) => {
      const img = new Image()
      img.addEventListener('load', () => {
        replaceBaseTexture(textureName, (new BaseTexture(img)))
        this.forceUpdate()
      })
      img.src = ev.target.result
    })

    reader.readAsDataURL(files[0])
  }

  render() {
    const { textureName, isSpine } = this.props
    const texture = getLocalTexture(textureName)

    return (
      <div className="devTextureSelector" style={{ padding: '2px', border: '1px solid #565656' }}>
        <span className="label">{textureName}</span>
        <div
          className="textureContainer"
          style={{
            minWidth: '100px', minHeight: '100px', display: 'flex', alignItems: 'center'
          }}
        >
          <ImgFromTexture width={100} height={100} keepDimensions texture={texture} />
        </div>
        { !isSpine && <input className="replacementControls" type="file" id={textureName} accept="image/*" onChange={this.replaceTexture} /> }
      </div>
    )
  }
}
